import svg4everybody from 'svg4everybody';

export default function(firstBlood) {
    svg4everybody();

    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        $('html').addClass('is-ios');
    }

    if(navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
        $('html').addClass('is-ie');
    }
}
